var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.userList),function(user){return _c('div',{key:user.id},[_c('user-list-item',{attrs:{"user":user}})],1)}),(_vm.isEmptyList)?_c('div',[_c('h5',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$t("emptyList")))])]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }